import { Block } from '@/core/Block'

export class FilteredList extends Block {
  async init() {
    super.init()

    this.activeFilters = []
    this.maxAmount = 9

    this.loadMore = this.get('.c-pagination-load-more, [data-filtered-load-more] .c-button')
    this.filterButtons = this.getAll('[data-filter-type]')

    this.loadMoreItems = this.loadMoreItems.bind(this)
    this.onFilterClick = this.onFilterClick.bind(this)
    this.activeFilter = 'all'
  }

  addEvents() {
    super.addEvents()

    if (this.loadMore) this.loadMore.addEventListener('click', this.loadMoreItems)
    this.filterButtons.forEach((button) => button.addEventListener('click', this.onFilterClick))
  }

  destroy() {
    super.destroy()

    if (this.loadMore) this.loadMore.removeEventListener('click', this.loadMoreItems)
    this.filterButtons.forEach((button) => button.removeEventListener('click', this.onFilterClick))
  }

  onFilterClick(e) {
    this.activeFilter = e.target.dataset.filterType

    // Add active filter to array
    if (this.activeFilters.includes(this.activeFilter)) {
      this.activeFilters = this.activeFilters.filter((filter) => filter !== this.activeFilter)
    } else {
      this.activeFilters.push(this.activeFilter)
    }

    const allButton = this.get('[data-filter-type="all"]')

    if (e.target.dataset.filterType === 'all') {
      this.activeFilters = []
      this.filterButtons.forEach((button) => {
        button.classList.remove('is-active')
      })
      allButton.classList.add('is-active')
    } else {
      allButton.classList.remove('is-active')

      // Add active class to all active filters
      this.filterButtons.forEach((button) => {
        if (this.activeFilters.includes(button.dataset.filterType)) {
          button.classList.add('is-active')
        } else {
          button.classList.remove('is-active')
        }
      })
    }

    if (this.activeFilters.length === 0) {
      allButton.classList.add('is-active')
    }

    this.renderItems(this.activeFilters)
  }

  loadMoreItems(e) {
    e.preventDefault()
    this.maxAmount += 9
    this.renderItems(this.activeFilter)
  }

  filterData(data, filterProp = 'categories') {
    return data.filter((entry) => {
      if (this.activeFilters.length === 0) {
        return true
      } else {
        return this.activeFilters.some((filter) => entry[filterProp].includes(filter))
      }
    })
  }

  async fetchData(file) {
    const uniqueCandidates = this.buildFetchCandidates(file)

    let lastError = null

    for (const candidate of uniqueCandidates) {
      try {
        const response = await fetch(candidate, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
          credentials: 'same-origin',
        })

        if (!response.ok) {
          throw new Error(`Request failed (${response.status}) for ${candidate}`)
        }

        return await response.json()
      } catch (error) {
        lastError = error
      }
    }

    throw lastError || new Error(`Unable to fetch data for ${file}`)
  }

  buildFetchCandidates(file) {
    if (!file || typeof file !== 'string') return []

    let absoluteUrl

    try {
      absoluteUrl = new URL(file, window.location.href)
    } catch (error) {
      return [file]
    }

    // Harden against mixed-content when same-host URLs are accidentally rendered as http.
    if (window.location.protocol === 'https:' && absoluteUrl.protocol === 'http:' && absoluteUrl.host === window.location.host) {
      absoluteUrl.protocol = 'https:'
    }

    const normalizedPath = absoluteUrl.pathname.replace(/\/{2,}/g, '/')
    const noSlashPath = normalizedPath.replace(/\/+$/, '') || '/'
    const withSlashPath = noSlashPath === '/' ? '/' : `${noSlashPath}/`
    const prefersTrailingSlash = /\/$/.test(file)

    const variants = prefersTrailingSlash ? [withSlashPath, noSlashPath] : [noSlashPath, withSlashPath]
    const candidates = variants.map((pathname) => {
      const url = new URL(absoluteUrl.toString())
      url.pathname = pathname
      return url.toString()
    })

    return [...new Set(candidates)]
  }

  renderLoadMore(slicedItems, itemsToRender) {
    this.loadMore = this.get('.c-pagination-load-more, [data-filtered-load-more] .c-button')

    if (this.loadMore) {
      if (slicedItems.length < this.maxAmount || slicedItems.length === itemsToRender.length) {
        this.loadMore.style.display = 'none'
      } else {
        this.loadMore.style.display = 'flex'
      }
    }
  }

  renderItems() {}
}
